// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingFlatFieldWithFacts-modulefacts__fbyEn";
var _2 = "RentalPortalListingFlatFieldWithFacts-moduleinput__BhvWJ Field-modulefieldInput__zmS30";
export { _1 as "facts", _2 as "input" }
